import { Grid, Box, Stack } from '@mui/material';
import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { ControlledTextInput, WsButton } from 'wisestep-base';

import FAQDetailsDetailsCommonFields from '../FAQDetailsCommonFields';
import FAQDetailsPage from '../FAQDetailsPage';

const Jobs = () => {
  const methods = useForm();

  const jobs = [
    {
      title:
        'Q: I posted my Job and have Candidate Submissions, but I forget to share `Job Management Rights` with my team. How can I do it Later ?',
      text: 'A: Once your Job is posted, you can click on the “Job Management Rights “and select a team to assign it to. You can also select if you want to apply these Job and Candidate management privileges to all prior Submitted Candidates and Candidate Mappings. With Job Management Rights shared, your team members can update, edit Statuses of Candidates Submitted to the Jobs.',
      optionalText: '',
    },
    {
      title: 'Q: I am unable to Edit a Job ?',
      text: 'A: You will be able to edit Jobs that are posted by you or for which you or your team has been provided Job Management Rights. If you are unable to edit a Job, then you should ask the person or team that assigned that Job to you. This can be found just below the Job with the following text “Assigned to you by X (Team Y) Z days ago”.',
      optionalText: '',
    },
    {
      title: 'Q:I am not able to create teams. What should I do ?',
      text: 'A: Team Creation privileges are not enabled by default. If you need to create teams write to us at support@wisestepmail.com for more details',
      optionalText: '',
    },
    {
      title: 'Q: What does assigning a Jobs to other Teams or Recruiters mean ?',
      text: 'A: Assigning a Job to other Teams or Recruiters means that you are inviting them to work on this open position and submit Candidates for this role. The “Assigned” Recruiters only have privileges to view the Job and Submit Candidates to it. They cannot update or edit the Job or update the Candidate status.',
      optionalText:
        ' Assigned Recruiters or Teams are different from the “Job Management Rights” that allow people to Edit, Manage, Close the Job and update the status of Submitted Candidates.',
    },
    {
      title: 'Q: How do I assign Jobs to other Teams and Recruiters mean ?',
      text: 'A: Once you complete posting your Job you will get an option to assign the Job to teams or individuals.',
      optionalText: '',
    },
    {
      title: 'Q: I forgot to Assign the Job once it was posted? How can I assign it ?',
      text: 'A: You can select the checkbox in front of the Job and click on “Assign Recruiters” button on the top and select teams or Recruiters from the list shown to you.',
      optionalText: '',
    },
    {
      title: 'Q: I just posted a Job. Can I assign the Job to anyone ?',
      text: 'A: You can assign Jobs to teams that are created by the same Team Owner. If you want to assign your Job to other people outside your company then write to us to become part of our partner program on partner@wisestepmail.com',
      optionalText: '',
    },
    {
      title: 'Q: I just posted a Job. Can I assign the Job to anyone ?',
      text: 'A: Wisestep takes Data Privacy Seriously. All Candidates Records have Data Privacy options and you can mark Candidates to be added to the Resctrict List, Forget List or the Delete List.',
      optionalText: '',
    },
    {
      title: 'Q: I am unable to update the status of Submitted Candidates ?"',
      text: 'A: You will be able to update the status of Candidates for which you or your team has been provided “Job Management Rights”. If you are unable to update the Candidate status, then you should ask the person or team that assigned that Job to you. This can be found just below the Job with the following text “Assigned to you by X (Team Y) Z days ago”.mation and profile captured Is available for you to search for re - use later.',
      optionalText: '',
    },
    {
      title: 'Q: How do I know that I can edit the Job or update Candidates submitted a Job ?',
      text: 'A: Below every Job Record, there are 2 types of messages “Job Posted by A (Team B) C days ago” OR“ Assigned to you by X(Team Y) Z days ago”.If you posted the Job or are part of the team that posted the Job, then you can“ Edit the Job” and“ Update Submitted Candidate Status”',
      optionalText: '',
    },
    {
      title: 'Q: How do I manage Data Privacy of Candidates ?',
      text: 'A: Wisestep takes Data Privacy Seriously. All Candidates Records have Data Privacy options and you can mark Candidates to be added to the Resctrict List, Forget List or the Delete List.',
      optionalText: '',
    },
    {
      title: 'Q: How can I see which teams I am part of ?',
      text: 'A: On the Top Menu look for the Teams Tab and under it click on the“ My Teams” link. This will show you the list of all the teams you are part of and the number of members of each team.',
      optionalText: '',
    },
    {
      title: 'Q: What happens to Candidates in the Delete List ?',
      text: 'A: Candidates from the Delete List will not show up in the Search and all their Contact information (except email address) along with “ Jobs contacted for”, CVs, Conversations are Deleted from the Wisestep platform.Any submissions made to clients are not deleted.',
      optionalText:
        'Email address are retained so that if someone adds the Candidate again by mistake, they are reminded that the Candidate is on the delete list.',
    },
    {
      title:
        'Q: How can I unsubscribe from certain types of notification emails like when a Job is posted, or shared, or a Candidate status is updated or submitted ?',
      text: 'A: In the Teams Section click on the“ Gears” icon that shows you the list of different notification events. You can click on“ Unsubscribe” on the ones you don’t want. You can“ Subscribe” to them again any time you want',
      optionalText: '',
    },
    {
      title: 'Q: Why do I have to assign Jobs to teams and not individuals ?',
      text: 'A: Wisestep works best when people are part of teams.Assigning Jobs to Individuals will be offered in the future.',
      optionalText: '',
    },
  ];

  const [jobsList, setJobsList] = useState<
    { title: string; text: string; optionalText: string }[] | undefined
  >(jobs);

  const [textValue, setTextValue] = useState('');

  const handleOnClick = () => {
    const findText =
      jobs && jobs?.length > 0
        ? jobs?.filter((b) => b?.title.toUpperCase().includes(textValue.toUpperCase()))
        : undefined;
    setJobsList(findText);
  };
  return (
    <FAQDetailsPage>
      <Box pt={2}>
        <FormProvider {...methods}>
          <Grid item xs={12} pb={2} bgcolor="white" p={2}>
            <Stack direction="row" spacing={1}>
              <ControlledTextInput
                placeholder="Search..."
                name="search"
                type="text"
                fullWidth
                required
                autoComplete="text"
                value={textValue}
                onChange={(e) => setTextValue(e.target.value)}
              />
              <WsButton disabled={!textValue} size="large" onClick={handleOnClick}>
                Search
              </WsButton>
            </Stack>
          </Grid>
          <Grid container spacing={2} pt={2}>
            {jobsList &&
              jobsList?.length > 0 &&
              jobsList?.map((list, index) => (
                <Grid item xs={12} key={index}>
                  <FAQDetailsDetailsCommonFields
                    title={list.title}
                    text={list.text}
                    optionalText={list.optionalText}
                  />
                </Grid>
              ))}
          </Grid>
        </FormProvider>
      </Box>
    </FAQDetailsPage>
  );
};

export default Jobs;
